import { Tag } from 'antd';

export const resolveRecipeById = (recipes, recipeId) =>
  (recipes || []).find((r) => Number(r.recipe_id) === Number(recipeId));

/** Keep only finalized recipes (Issue Batch / Create Demand dropdowns). */
export const filterFinalizedRecipes = (rows, finalizedIds) => {
  const list = rows || [];
  if (!list.length) return [];
  if (list.some((r) => typeof r.is_finalized === 'boolean')) {
    return list.filter((r) => r.is_finalized === true);
  }
  if (finalizedIds && finalizedIds.size > 0) {
    return list.filter((r) => finalizedIds.has(Number(r.recipe_id)));
  }
  return list;
};

/** Ant Design Select options for versioned MBMR/recipe lists. */
export function buildVersionedRecipeSelectOptions(recipes) {
  const list = recipes || [];
  const rootIdsWithVersions = new Set(
    list
      .map((r) => Number(r.version_root_id))
      .filter((id) => !Number.isNaN(id) && id > 0)
  );
  const families = {};
  const standalone = [];

  list.forEach((r) => {
    const recipeId = Number(r.recipe_id);
    const rootId = r.version_root_id != null ? Number(r.version_root_id) : null;
    if (rootId) {
      (families[rootId] ||= {
        label: r.version_root_name || 'Versions',
        items: [],
      }).items.push(r);
    } else if (rootIdsWithVersions.has(recipeId)) {
      (families[recipeId] ||= {
        label: r.recipe_name || 'Versions',
        items: [],
      }).items.push(r);
    } else {
      standalone.push(r);
    }
  });

  const versionBadge = (r) =>
    r?.version_label ||
    (r?.version_number != null && r?.version_number !== '' ? `v${r.version_number}` : null);

  const toOption = (r) => {
    const badge = versionBadge(r);
    const searchLabel = [badge, r.recipe_name].filter(Boolean).join(' ');
    return {
      value: Number(r.recipe_id),
      label: (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          {badge ? (
            <Tag color="blue" style={{ marginInlineEnd: 0, lineHeight: '18px' }}>
              {badge}
            </Tag>
          ) : null}
          {r.recipe_name}
        </span>
      ),
      title: searchLabel,
      'data-label': searchLabel,
    };
  };

  const sortVersions = (a, b) =>
    (Number(a.version_number) || 0) - (Number(b.version_number) || 0);

  const options = standalone.map(toOption);
  Object.values(families).forEach((fam) => {
    options.push({
      label: fam.label,
      title: fam.label,
      options: fam.items.slice().sort(sortVersions).map(toOption),
    });
  });
  return options;
}
